// docs: https://github.com/altostra/type-validations#readme
import { objectOf, recordOf, maybe } from "@altostra/type-validations";
import { number, nullOrUndefined } from "@altostra/type-validations/lib/primitives";

const platformStats = maybe(
  objectOf({
    impressions: number,
    clicks: number,
    first_button_clicks: number,
    second_button_clicks: number,
    button_clicks: number,
  })
);

const allStats = maybe(
  objectOf({
    enrolled: number,
    revenue: number,
    unique_recipients: number,
    uninstall_score_absolute: number,
    conversions: number,
    conversions_by_send_time: number,
    conversions1: number,
    conversions1_by_send_time: number,
    conversions2: number,
    conversions2_by_send_time: number,
    conversions3: number,
    conversions3_by_send_time: number,
    deprioritized_total: maybe(number),
    retried_total: maybe(number),
  })
);

export const isEngagementCampaignStats = objectOf({
  data: recordOf(
    objectOf({
      all: allStats,
      iOS: platformStats,
      Android: platformStats,
      "Windows Universal": platformStats,
      Kindle: platformStats,
      "Android China": platformStats,
      Web: platformStats,
      tvOS: platformStats,
      Roku: platformStats,
    })
  ),
  recent_num_frequency_capped: number,
  recent_num_deprioritized: maybe(number),
  keyword_names_to_ids: objectOf({}),
  ancillary_data: nullOrUndefined,
  total_sends: number,
  optimization_uplift: maybe(number),
});
